var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.997 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm0 4a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 3C2.392 14 .162 8.74.072 8.5a1 1 0 0 1 0-.745C.157 7.535 2.377 2 7.998 2c5.62 0 7.84 5.535 7.93 5.77a1 1 0 0 1 0 .745c-.095.225-2.325 5.486-7.93 5.486Zm-5.9-5.875c.545 1.035 2.355 3.876 5.9 3.876 3.546 0 5.35-2.85 5.9-3.88-.54-1.09-2.35-4.12-5.9-4.12-3.55 0-5.365 3.034-5.9 4.124Z",
    clipRule: "evenodd"
  })));
};
export default SvgEye;